import React, { useMemo } from "react";
import { View } from "react-native";
import { Logo } from "../../../../../components/atoms/logo/Logo";
import { ButtonIcon } from "../../../../../components/molecules/buttonIcon/ButtonIcon";
import { style as headerStyle } from "./Header.style";
const Header = ({ onPressMenu }) => {
    const style = useMemo(() => headerStyle(), []);
    return (React.createElement(View, { style: style.header, testID: "default-header" },
        React.createElement(Logo, null),
        React.createElement(View, { style: style.buttonIconPlaceholder }),
        React.createElement(ButtonIcon, { name: "menu", style: { button: style.button }, testID: "menu-button-icon", onPress: onPressMenu })));
};
export { Header };
